import React, { useState, useEffect } from 'react';
import InputList from './InputList';

const IL_Oddities = ({
  questionnaireCriteria,
  onCriteriaChange,
  label = "Oddities",
  placeholder = "Enter an oddity...",
  emptyMessage = "No oddities added yet"
}) => {

  // Extract oddities from questionnaire criteria
  const getInitialOddities = () => {
    if (questionnaireCriteria?.oddities?.items) {
      return questionnaireCriteria.oddities.items.map(item => ({
        title: item.oddity,
        subtitle: item.rationale || ''
      }));
    }
    return [];
  };

  // State for oddities
  const [oddities, setOddities] = useState(getInitialOddities());

  // Update oddities when questionnaireCriteria changes
  useEffect(() => {
    setOddities(getInitialOddities());
  }, [questionnaireCriteria]);

  // Update oddities criteria JSON
  const updateOdditiesCriteria = (newOddities) => {
    if (!questionnaireCriteria) return;

    // Create updated criteria with new oddities
    const updatedCriteria = {
      ...questionnaireCriteria,
      oddities: {
        ...questionnaireCriteria.oddities,
        items: newOddities.map(oddityItem => {
          // Check if this oddity already exists in our current criteria
          const existingOddity = questionnaireCriteria.oddities?.items?.find(
            item => item.oddity === oddityItem.title
          );
          
          if (existingOddity) {
            // Keep existing oddity with all its properties
            return existingOddity;
          } else {
            // Create new oddity entry with oddities specific structure
            return {
              oddity: oddityItem.title,
              rationale: oddityItem.subtitle || ""
            };
          }
        }),
        llminstruction: questionnaireCriteria.oddities?.llminstruction || "Ask the candidate to explain these anomalies in a neutral, open‑ended way—focus on context and learnings rather than judgment."
      }
    };

    // Call parent callback with only the updated criteria
    onCriteriaChange(updatedCriteria);
  };

  // Handle oddities change
  const handleOdditiesChange = (newOddities) => {
    setOddities(newOddities);
    updateOdditiesCriteria(newOddities);
  };

  return (
    <InputList
      items={oddities}
      onItemsChange={handleOdditiesChange}
      label={label}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
    />
  );
};

export default IL_Oddities;
